import {Component, NgZone, OnInit, ViewEncapsulation} from '@angular/core';
import {EbmsVeeyaaConfig} from '../../../../app-config';
import {Location} from '@angular/common';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfigurationComponent implements OnInit {
  public styleSelectorToggle: boolean; // open configuration menu
  public layoutType: string; // layout type
  public rtlLayout: any; // rtl type
  public menuFixedLayout: any; // menu/navbar fixed flag
  public headerFixedLayout: any; // header fixed flag
  public boxLayout: any; // box layout flag
  public headerBackgroundColor: string; // header background color
  public brandBackgroundColor: string; // brand/logo background color

  public headerBackColor: string;

  public ebmsVeeyaaConfig: any;
  public isConfig: boolean;

  scroll = (): void => {
    if (this.headerFixedLayout === false) {
      const navPsNext = document.querySelector('#nav-ps-next') as HTMLElement;
      if (navPsNext) {
        navPsNext.style.maxHeight = 'calc(100vh)';
      }
      const el = document.querySelector('.pcoded-navbar.menupos-fixed') as HTMLElement;
      const scrollPosition = window.pageYOffset;
      if (scrollPosition > 60 && el) {
        el.style.position = 'fixed';
        el.style.transition = 'none';
        el.style.marginTop = '0';
      } else if (el) {
        el.style.position = 'absolute';
        el.style.marginTop = '60px';
      }
    } else {
      const navbar = document.querySelector('.pcoded-navbar');
      const navbarFixed = document.querySelector('.pcoded-navbar.menupos-fixed');
      if (navbar && navbar.hasAttribute('style')) {
        if (navbarFixed) {
          navbarFixed.removeAttribute('style');
        }
      }
      
      // Also handle unified navigation
      const unifiedNav = document.querySelector('.unified-nav');
      if (unifiedNav && unifiedNav.hasAttribute('style')) {
        unifiedNav.removeAttribute('style');
      }
    }
  }

  constructor(private zone: NgZone, private location: Location) {
    this.ebmsVeeyaaConfig = EbmsVeeyaaConfig.config;
    this.setThemeLayout();
  }

  ngOnInit() {
    this.styleSelectorToggle = false;

    this.layoutType =  this.ebmsVeeyaaConfig.layoutType;
    this.setLayout(this.layoutType);

    this.headerBackgroundColor = this.ebmsVeeyaaConfig.headerBackColor;
    this.brandBackgroundColor = this.ebmsVeeyaaConfig.navBrandColor;

    this.setHeaderBackground(this.headerBackgroundColor);
    this.setBrandBackground(this.brandBackgroundColor);

    this.rtlLayout = this.ebmsVeeyaaConfig.rtlLayout;
    this.changeRtlLayout(this.rtlLayout);

    this.menuFixedLayout = this.ebmsVeeyaaConfig.navFixedLayout;
    if (this.ebmsVeeyaaConfig.layout === 'vertical') {
      this.changeMenuFixedLayout(this.menuFixedLayout);
    }

    this.headerFixedLayout = this.ebmsVeeyaaConfig.headerFixedLayout;
    this.changeHeaderFixedLayout(this.headerFixedLayout);

    this.boxLayout = this.ebmsVeeyaaConfig.boxLayout;
    this.changeBoxLayout(this.boxLayout);
  }

  setThemeLayout() {
    let currentURL = this.location.path();
    const baseHref = this.location['_baseHref'];
    if (baseHref) {
      currentURL = baseHref + this.location.path();
    }

    switch (currentURL) {
      case baseHref + '/layout/static':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.navFixedLayout = false;
        this.ebmsVeeyaaConfig.headerFixedLayout = false;
        break;
      case baseHref + '/layout/fixed':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.navFixedLayout = true;
        this.ebmsVeeyaaConfig.headerFixedLayout = true;
        break;
      case baseHref + '/layout/nav-fixed':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.navFixedLayout = true;
        this.ebmsVeeyaaConfig.headerFixedLayout = false;
        break;
      case baseHref + '/layout/collapse-menu':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.collapseMenu = true;
        break;
      case baseHref + '/layout/vertical-rtl':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.rtlLayout = true;
        break;
      case baseHref + '/layout/horizontal':
        this.ebmsVeeyaaConfig.layout = 'horizontal';
        this.ebmsVeeyaaConfig.navFixedLayout = false;
        this.ebmsVeeyaaConfig.headerFixedLayout = false;
        break;
      case baseHref + '/layout/horizontal-l2':
        this.ebmsVeeyaaConfig.layout = 'horizontal';
        this.ebmsVeeyaaConfig.subLayout = 'horizontal-2';
        this.ebmsVeeyaaConfig.navFixedLayout = false;
        this.ebmsVeeyaaConfig.headerFixedLayout = false;
        break;
      case baseHref + '/layout/horizontal-rtl':
        this.ebmsVeeyaaConfig.layout = 'horizontal';
        this.ebmsVeeyaaConfig.subLayout = 'horizontal-2';
        this.ebmsVeeyaaConfig.navFixedLayout = false;
        this.ebmsVeeyaaConfig.headerFixedLayout = false;
        this.ebmsVeeyaaConfig.rtlLayout = true;
        break;
      case baseHref + '/layout/box':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.boxLayout = true;
        this.ebmsVeeyaaConfig.headerFixedLayout = false;
        this.ebmsVeeyaaConfig.collapseMenu = true;
        break;
      case baseHref + '/layout/light':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.layoutType = 'menu-light';
        this.ebmsVeeyaaConfig.headerBackColor = 'header-default';
        break;
      case baseHref + '/layout/dark':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.layoutType = 'dark';
        this.ebmsVeeyaaConfig.headerBackColor = 'header-blue';
        break;
      case baseHref + '/layout/nav-color':
        this.ebmsVeeyaaConfig.layout = 'vertical';
        this.ebmsVeeyaaConfig.layoutType = 'menu-light';
        this.ebmsVeeyaaConfig.headerBackColor = 'header-info';
        this.ebmsVeeyaaConfig.navBrandColor = 'brand-info';
        this.ebmsVeeyaaConfig.navFixedLayout = true;
        this.ebmsVeeyaaConfig.headerFixedLayout = true;
        break;
      default:
        break;
    }
  }

  setHeaderBackColor(color) {
    this.headerBackColor = color;
    const body = document.querySelector('body') as HTMLElement;
    if (body) {
      body.style.background = color;
    }
  }

  // change main layout
  setLayout(layout) {
    this.isConfig = true;
    this.setBrandBackground(this.ebmsVeeyaaConfig.navBrandColor);
    
    // Check if old navigation exists before manipulating
    const oldNavbar = document.querySelector('.pcoded-navbar');
    if (oldNavbar) {
      oldNavbar.classList.remove('menu-light');
      oldNavbar.classList.remove('menu-dark');
      oldNavbar.classList.remove('navbar-dark');
      oldNavbar.classList.remove('brand-dark');
    }
    
    // Apply to new unified navigation
    const unifiedNav = document.querySelector('.unified-nav');
    if (unifiedNav) {
      unifiedNav.classList.remove('menu-light');
      unifiedNav.classList.remove('menu-dark');
      unifiedNav.classList.remove('navbar-dark');
      unifiedNav.classList.remove('brand-dark');
    }
    
    document.querySelector('body').classList.remove('next-dark');

    this.layoutType = layout;
    if (layout === 'menu-light') {
      this.setBrandBackground(this.brandBackgroundColor);
      if (oldNavbar) {
        oldNavbar.classList.add(layout);
      }
      if (unifiedNav) {
        unifiedNav.classList.add(layout);
      }
    }
    if (layout === 'dark') {
      if (oldNavbar) {
        oldNavbar.classList.add('navbar-dark');
        oldNavbar.classList.add('brand-dark');
      }
      if (unifiedNav) {
        unifiedNav.classList.add('navbar-dark');
        unifiedNav.classList.add('brand-dark');
      }

      this.setBrandBackground('brand-blue');
      this.setHeaderBackground('header-blue');

      document.querySelector('body').classList.add('next-dark');
    }
    if (layout === 'reset') {
      this.reset();
    }
  }

  reset() {
    const oldNavbar = document.querySelector('.pcoded-navbar');
    if (oldNavbar) {
      oldNavbar.classList.remove('icon-colored');
    }
    
    const unifiedNav = document.querySelector('.unified-nav');
    if (unifiedNav) {
      unifiedNav.classList.remove('icon-colored');
    }
    
    this.ngOnInit();
  }

  setRtlLayout(e) {
    const flag = !!(e.target.checked);
    this.changeRtlLayout(flag);
  }

  changeRtlLayout(flag) {
    if (flag) {
      document.querySelector('body').classList.add('next-rtl');
    } else {
      document.querySelector('body').classList.remove('next-rtl');
    }
  }

  setMenuFixedLayout(e) {
    const flag = !!(e.target.checked);
    this.changeMenuFixedLayout(flag);
  }

  changeMenuFixedLayout(flag) {
    setTimeout(() => {
      const navbar = document.querySelector('.pcoded-navbar');
      const unifiedNav = document.querySelector('.unified-nav');
      const navPsNext = document.querySelector('#nav-ps-next') as HTMLElement;
      
      if (flag) {
        if (navbar) {
          navbar.classList.remove('menupos-static');
          navbar.classList.add('menupos-fixed');
        }
        if (unifiedNav) {
          unifiedNav.classList.remove('menupos-static');
          unifiedNav.classList.add('menupos-fixed');
        }
        if (this.ebmsVeeyaaConfig.layout === 'vertical' && navPsNext) {
          navPsNext.style.maxHeight = 'calc(100vh - 60px)'; // calc(100vh - 70px) amit
        }
        window.addEventListener('scroll', this.scroll, true);
        window.scrollTo(0, 0);
      } else {
        if (navbar) {
          navbar.classList.add('menupos-static');
          navbar.classList.remove('menupos-fixed');
        }
        if (unifiedNav) {
          unifiedNav.classList.add('menupos-static');
          unifiedNav.classList.remove('menupos-fixed');
        }
        if (this.ebmsVeeyaaConfig.layout === 'vertical' && navPsNext) {
          navPsNext.style.maxHeight = 'calc(100%)'; // calc(100% - 70px) amit
        }
        if (this.ebmsVeeyaaConfig.layout === 'vertical') {
          window.removeEventListener('scroll', this.scroll, true);
        }

      }
    }, 100);
  }

  setHeaderFixedLayout(e) {
    const flag = !!(e.target.checked);
    this.changeHeaderFixedLayout(flag);
  }

  changeHeaderFixedLayout(flag) {
    if (flag) {
      document.querySelector('.pcoded-header').classList.add('headerpos-fixed');
    } else {
      document.querySelector('.pcoded-header').classList.remove('headerpos-fixed');
      // static
      if (this.ebmsVeeyaaConfig.layout === 'vertical' && this.menuFixedLayout) {
        window.addEventListener('scroll', this.scroll, true);
        window.scrollTo(0, 0);
      } else {
        window.removeEventListener('scroll', this.scroll, true);
      }
    }
  }

  setBoxLayout(e) {
    const flag = !!(e.target.checked);
    this.changeBoxLayout(flag);
  }

  changeBoxLayout(flag) {
    if (flag) {
      document.querySelector('body').classList.add('container');
      document.querySelector('body').classList.add('box-layout');
    } else {
      document.querySelector('body').classList.remove('box-layout');
      document.querySelector('body').classList.remove('container');
    }
  }

  setHeaderBackground(background) {
    this.headerBackgroundColor = background;
    this.ebmsVeeyaaConfig.headerBackColor = background;
    document.querySelector('.pcoded-header').classList.remove('header-blue');
    document.querySelector('.pcoded-header').classList.remove('header-red');
    document.querySelector('.pcoded-header').classList.remove('header-purple');
    document.querySelector('.pcoded-header').classList.remove('header-info');
    document.querySelector('.pcoded-header').classList.remove('header-dark');

    if (background !== 'header-default') {
      document.querySelector('.pcoded-header').classList.add(background);
    }
  }

  setBrandBackground(background) {
    this.brandBackgroundColor = background;
    this.ebmsVeeyaaConfig.navBrandColor = background;
    document.querySelector('.pcoded-header').classList.remove('brand-blue');
    document.querySelector('.pcoded-header').classList.remove('brand-red');
    document.querySelector('.pcoded-header').classList.remove('brand-purple');
    document.querySelector('.pcoded-header').classList.remove('brand-info');
    document.querySelector('.pcoded-header').classList.remove('brand-dark');
    document.querySelector('.pcoded-header').classList.remove('brand-default');
    document.querySelector('.pcoded-header').classList.add(background);
  }

}
